module.exports = __webpack_public_path__ + "img/zk-icon-shop-decoration.4843d549.svg";